export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4714.b8e19447.jpg";